// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@900&family=Raleway&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  font-family: "Raleway", sans-serif;
  margin: 0px;
  width: calc(var(--vw, 1vw) * 100);
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-direction: column;

  margin-left: auto;
  margin-right: auto;
  max-height: 100vh;
}

html,
body {
  margin: 0px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  -webkit-user-select: none; /* Safari */ /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  /* overscroll-behavior-x: none; */
}

.app-game-container {
  flex: 1 1;
  margin: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

html {
  overscroll-behavior: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;;EAEtB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,yBAAyB,EAAE,WAAW,EACf,oBAAoB;EAC3C,iBAAiB,EAAE,oBAAoB;EACvC,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@900&family=Raleway&display=swap\");\n\n.App {\n  text-align: center;\n  font-family: \"Raleway\", sans-serif;\n  margin: 0px;\n  width: calc(var(--vw, 1vw) * 100);\n  height: calc(var(--vh, 1vh) * 100);\n  display: flex;\n  flex-direction: column;\n\n  margin-left: auto;\n  margin-right: auto;\n  max-height: 100vh;\n}\n\nhtml,\nbody {\n  margin: 0px;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  -webkit-user-select: none; /* Safari */\n  -ms-user-select: none; /* IE 10 and IE 11 */\n  user-select: none; /* Standard syntax */\n  /* overscroll-behavior-x: none; */\n}\n\n.app-game-container {\n  flex: 1;\n  margin: 0px;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\nhtml {\n  overscroll-behavior: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
